<script setup>
import { SecondaryButton } from "@Components/Button";
import { FormInput } from "@Components/Form";
import { PlusIcon, TrashIcon } from "lucide-vue-next";
import { useI18n } from "vue-i18n";

const props = defineProps({
    modelValue: {
        type: Array,
        default: [],
    },
});

const emit = defineEmits(["update:modelValue"]);

const { t: __ } = useI18n();

const addEmptyLink = () => {
    props.modelValue.push("");
};

const removeLink = (index) => {
    props.modelValue.splice(index, 1);
};
</script>

<template>
    <div>
        <div class="block text-sm font-medium leading-6 text-gray-900 dark:text-white">
            {{ __("Ajoutez les URLs des données que vous souhaitez extraire") }}
        </div>
        <div class="flex flex-col gap-3 mt-2">
            <div v-for="(link, index) in modelValue" :key="index">
                <div class="flex justify-between items-center gap-3">
                    <div class="flex-1">
                        <FormInput v-model="modelValue[index]" :placeholder="__('http://')" />
                    </div>
                    <div class="flex-none">
                        <SecondaryButton @click.prevent="removeLink(index)" :z="1">
                            <TrashIcon class="w-4 h-4" />
                        </SecondaryButton>
                    </div>
                </div>
            </div>
            <SecondaryButton v-if="modelValue.length < 3" @click.prevent="addEmptyLink" :z="1" class="justify-center" :icon="PlusIcon" />
        </div>
    </div>
</template>
